module.exports = __webpack_public_path__ + "img/download_back.2066adf.png";